import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RetornoApi } from "src/app/models/retornoApi.model";
import { SpvAcompanhar } from "src/app/models/spv-acompanhar.model";
import { SCAMP_API, SCAMP_API_RPT } from "src/environments/environment";
import { SpvAprovadoParaQualificar } from "../models/spv-para-qualificar.model";
import { SpvDetalhes } from "../models/spvDetalhes.model";
import { AccountService } from "./account.service";

@Injectable({ providedIn: "root" })
export class SpvService {
  constructor(
    private http: HttpClient,
    private account: AccountService,
  ) {}

  save(data) {
    return this.http.post(`${SCAMP_API.accountApiV1}/spv`, data, {
      headers: this.account.composeHeaders(),
    });
  }

  /*  editar(id: number, data) {
        return this.http.put(`${SCAMP_API.accountApiV1}/spv/${id}`, data, {headers : this.account.composeHeaders()});
    } */

  /* getSpvsDetalhes(): Observable<SpvDetalhes[]> {
        return this.http.get<SpvDetalhes[]>(`${SCAMP_API.accountApiV1}/spvs/detalhes`, {headers : this.account.composeHeaders()});
    } */

  getSpvsAbertosPorUsuario(): Observable<SpvDetalhes[]> {
    return this.http.get<SpvDetalhes[]>(
      `${SCAMP_API.accountApiV1}/spvs-abertos-do-usuario`,
      { headers: this.account.composeHeaders() },
    );
  }

  getSpvsAbertos(): Observable<SpvDetalhes[]> {
    return this.http.get<SpvDetalhes[]>(
      `${SCAMP_API.accountApiV1}/spvs-abertos`,
      { headers: this.account.composeHeaders() },
    );
  }

  getSpvsAbertosQtd(): Observable<number> {
    return this.http.get<number>(`${SCAMP_API.accountApiV1}/spvs-abertos-qtd`, {
      headers: this.account.composeHeaders(),
    });
  }

  getSpvsParaQualificar(
    filtroAreaTecnicaId: number,
    empreiteiraId: number,
  ): Observable<SpvDetalhes[]> {
    return this.http.get<SpvDetalhes[]>(
      `${SCAMP_API.accountApiV1}/spvs-para-qualificar/${filtroAreaTecnicaId}/${empreiteiraId}`,
      { headers: this.account.composeHeaders() },
    );
  }

  getSpvsParaQualificarMarcados(spvIds: string): Observable<SpvDetalhes[]> {
    return this.http.post<SpvDetalhes[]>(
      `${SCAMP_API.accountApiV1}/spvs-para-qualificar/marcados`,
      { spvIds: spvIds },
      { headers: this.account.composeHeaders() },
    );
  }

  getSpvDetalhes(id: number): Observable<SpvDetalhes> {
    return this.http.get<SpvDetalhes>(
      `${SCAMP_API.accountApiV1}/spv-detalhes/${id}`,
      { headers: this.account.composeHeaders() },
    );
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${SCAMP_API.accountApiV1}/spv/${id}`, {
      headers: this.account.composeHeaders(),
    });
  }

  getSpvAprovadoParaQualificar(
    id: number,
  ): Observable<SpvAprovadoParaQualificar> {
    return this.http.get<SpvAprovadoParaQualificar>(
      `${SCAMP_API.accountApiV1}/spv-para-qualificar/${id}`,
      { headers: this.account.composeHeaders() },
    );
  }

  aprovarSpv(data) {
    return this.http.post(`${SCAMP_API.accountApiV1}/spv-aprovar`, data, {
      headers: this.account.composeHeaders(),
    });
  }

  getStatusSS(spvId: number): Observable<any> {
    return this.http.get<any>(
      `${SCAMP_API.accountApiV1}/ss/getstatus/${spvId}`,
      { headers: this.account.composeHeaders() },
    );
  }

  setIrregulariadeSpv(
    spvId: number,
    irregularidadeId: number,
  ): Observable<boolean> {
    return this.http.post<boolean>(
      `${SCAMP_API.accountApiV1}/spv/irregularidade/${spvId}/${irregularidadeId}`,
      null,
      { headers: this.account.composeHeaders() },
    );
  }

  recusarSpv(data) {
    return this.http.post(`${SCAMP_API.accountApiV1}/spv-recusar`, data, {
      headers: this.account.composeHeaders(),
    });
  }

  qualificarSpv(data) {
    return this.http.post(`${SCAMP_API.accountApiV1}/spv-qualificar`, data, {
      headers: this.account.composeHeaders(),
    });
  }

  getSSsPorPeriodo(data): Observable<SpvAcompanhar[]> {
    return this.http.post<SpvAcompanhar[]>(
      `${SCAMP_API.accountApiV1}/ss/por-periodo`,
      data,
      { headers: this.account.composeHeaders() },
    );
  }

  getSpvCompleto(id: number, tipoSpv: number): Observable<any> {
    if (tipoSpv === 1) {
      return this.http.get<any>(`${SCAMP_API.accountApiV1}/spv-completo/${id}`);
    }
    if (tipoSpv === 2) {
      return this.http.get<any>(`${SCAMP_API.accountApiV1}/pt-completo/${id}`);
    }
  }

  // Servidor de Relatórios
  getAcompanharSPVs(data): Observable<RetornoApi> {
    return this.http.post<RetornoApi>(
      `${SCAMP_API_RPT.accountApiV1}/spv-pesquisar-por-periodo`,
      data,
    );
  }
}
